import {
  FS_DOWNLOAD_FILE,
  FS_REMOVE_FILE,
  FS_UPDATE_LOCAL_FILE,
  KNOWLEDGE_UPDATE_ITEM_CONTENT,
} from '.';
import { isRelativePath } from '../selectors/fs.selector';
import { getKnowledgeItemById } from '../selectors/knowledge.selector';

/**
 * Records a finished download. With `item`, its row is written to the store
 * first: a client that reads rows on demand has no row for the item otherwise,
 * so the download would have nothing to show offline. The row is persisted
 * without `content` (see `STORAGE_REDUCERS_DATA_TO_ELIMINATE`); the file is
 * the download itself.
 *
 * @param {{ id: string, path: string, url: string, item?: object }} payload
 * @returns {(dispatch: Function) => void}
 * @example
 * dispatch(downloadFileUpdate({ id, path, url: link, item }));
 */
export const downloadFileUpdate =
  ({ item, ...file }) =>
  dispatch => {
    if (item) dispatch({ type: KNOWLEDGE_UPDATE_ITEM_CONTENT, payload: { item } });
    dispatch({ type: FS_DOWNLOAD_FILE, payload: file });
  };

export const removeFile = payload => ({
  type: FS_REMOVE_FILE,
  payload,
});

/**
 * Verify local download files against the new ones
 * And if needed send update event
 * @async
 */
export const verifyDownloadContentIsUpdated = () => async (dispatch, getState) => {
  let { fs, knowledge } = getState();

  Object.values(fs.map).forEach(file => {
    let { id, path } = file;
    let item = getKnowledgeItemById({ knowledge }, id);

    // Not in the store means not loaded, not deleted: the download stays.
    if (!item) return;

    // Check if have to update the file
    if (
      new Date(file.lastUpdated) > new Date(item.updatedAt) && // Check if the file updated after downloaded
      isRelativePath({ url: path }) // Fallback for temp download directory (iOS virtual directory)
    ) {
      return false;
    }

    dispatch(removeFile({ id }));

    dispatch(updateLocalFile({ id, item }));
  });
};

/**
 * Trigger update local file
 * @param {*} { id, item } - item id and the last updated item
 */
export const updateLocalFile = ({ id, item }) => ({
  type: FS_UPDATE_LOCAL_FILE,
  payload: { id, item },
});
